"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarkdownHeading5 = exports.MarkdownHeading4 = exports.MarkdownHeading3 = exports.MarkdownHeading2 = exports.MarkdownHeading1 = exports.MarkdownHeading = void 0;
var react_1 = __importDefault(require("react"));
var kebabCase_1 = __importDefault(require("lodash/kebabCase"));
var transliterate_1 = __importDefault(require("@sindresorhus/transliterate"));
var markdown_heading_module_css_1 = __importDefault(require("./markdown-heading.module.css"));
var renderers_1 = require("../renderers");
exports.MarkdownHeading = function (_ref) {
  var level = _ref.level,
    children = _ref.children,
    startHeader = _ref.startHeader,
    breakpoints = _ref.breakpoints;
  var tagLevel = renderers_1.normalizeHeaderLevel(level, startHeader);
  var Tag = "h".concat(tagLevel);
  var childrenValues = react_1.default.Children.map(children, function (item) {
    var value = react_1.default.isValidElement(item) ? item.props.value : typeof item === 'string' ? item : null;
    if (value) {
      if (value.startsWith('^')) {
        var str = value.substr(1);
        var slug = kebabCase_1.default(transliterate_1.default(str));
        return react_1.default.createElement("span", {
          className: markdown_heading_module_css_1.default.headingAnchor
        }, react_1.default.createElement("a", {
          "aria-hidden": "true",
          tabIndex: -1,
          id: slug,
          className: markdown_heading_module_css_1.default.anchor
        }), str, react_1.default.createElement("a", {
          href: "#".concat(slug),
          className: markdown_heading_module_css_1.default.hashLink
        }, "\xA0#"));
      }
      if (value.includes('>')) {
        return react_1.default.createElement(react_1.default.Fragment, null, value.substring(0, value.indexOf('>')), renderers_1.renderBlockquote(value.substring(value.indexOf('>') + 1)));
      }
    }
    return item;
  });
  return react_1.default.createElement(Tag, {
    className: renderers_1.normalizeHeadingClassName({
      sharps: level,
      breakpoints: breakpoints
    })
  }, childrenValues);
};
exports.MarkdownHeading1 = function (props) {
  return react_1.default.createElement(exports.MarkdownHeading, Object.assign({
    level: 1
  }, props));
};
exports.MarkdownHeading2 = function (props) {
  return react_1.default.createElement(exports.MarkdownHeading, Object.assign({
    level: 2
  }, props));
};
exports.MarkdownHeading3 = function (props) {
  return react_1.default.createElement(exports.MarkdownHeading, Object.assign({
    level: 3
  }, props));
};
exports.MarkdownHeading4 = function (props) {
  return react_1.default.createElement(exports.MarkdownHeading, Object.assign({
    level: 4
  }, props));
};
exports.MarkdownHeading5 = function (props) {
  return react_1.default.createElement(exports.MarkdownHeading, Object.assign({
    level: 5
  }, props));
};